import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';

import threatEmulationIcon from '../../../../../assets/images/threat_emulation_64.png';
import sandBlastIcon from '../../../../../assets/images/reports/sand-blast.png';
import {SMCRadio, SMCRadioGroup} from '../../../../../components/Simple/SMCRadio';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import {SMCSelect, SMCOption} from '../../../../../components/Simple/SMCSelect';
import SMCNote from '../../../../../components/Simple/SMCNote';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.threatEmulation;
const pageId = pageSchema.pageId;

function BaseThreatEmulation({
    pageData,
    setObjectData,
    pageDisabled,
    setEditorPageId
}) {
    const { t } = useTranslation();

    const manageInSmp                = pageData[pageSchema.manageInSmp];
    const mode                       = pageData[pageSchema.mode];
    const detect                     = pageData[pageSchema.detect];
    const connectionHandlingModeHttp = pageData[pageSchema.connectionHandlingModeHttp];

    const connectionHandlingModeHttpValues = pageSchema.connectionHandlingModeHttpValues;

    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);


    return (
        <EditorLayout labelWidth={300}>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={manageInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <SMCNote>{t('SMP.PLAN.TE.LINE1')}</SMCNote>
            <PlanEditorInnerContainer title={<RowLayout spacing="8px">{t('SMP.PLANS.INNER_MENU.THREAT_EMULATION')}<img src={sandBlastIcon} alt="" /></RowLayout>} managedInSmp={manageInSmp}>
                <RowLayout>
                    <img alt="" src={threatEmulationIcon} />
                    <SMCRadioGroup value={mode ? 'ON' : 'OFF'} onChange={e => setPageValue(pageSchema.mode, e.target.value === 'ON')} disabled={pageDisabled || !manageInSmp}>
                        <SMCRadio value="ON" label={t('SMP.ON')} />
                        <SMCRadio value="OFF" label={t('SMP.OFF')} />
                    </SMCRadioGroup>
                </RowLayout>

                <SMCLabel bold>{t('SMP.PLAN.SEC_SOFT_BLADES.POLICY')}:</SMCLabel>
                <SMCLabel>{t('SMP.PLAN.TP_POLICY_SETTINGS_CONF')}<span className="Link" onClick={() => setEditorPageId(GatewayGetSchema.pages.threatPrevention.pageId)}> {t('SMP.PLAN.THREAT_PREV_POLICY')}</span></SMCLabel>
                <SMCLabel>{t('SMP.PLAN.UNIFIED_TP_POLICY_SETTINGS_CONF')}<span className="Link" onClick={() => setEditorPageId(GatewayGetSchema.pages.unifiedThreatPrevention.pageId)}> {t('SMP.PLAN.UNIFIED_THREAT_PREV_POLICY')}</span></SMCLabel>

                <EmptyRow />

                <SMCSelect
                    disabled={pageDisabled || !manageInSmp}
                    value={connectionHandlingModeHttp}
                    onChange={e => setPageValue(pageSchema.connectionHandlingModeHttp, e.target.value)}
                    label={t('SMP.PLAN.TE.LINE2')+':'}
                >
                    <SMCOption value={connectionHandlingModeHttpValues.background}>{t('SMP.PLAN.TE.BACKGROUND')}</SMCOption>
                    <SMCOption value={connectionHandlingModeHttpValues.hold}>{t('SMP.PLAN.TE.HOLD')}</SMCOption>
                </SMCSelect>

                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={detect}
                    onChange={e => setPageValue(pageSchema.detect, e.target.checked)}
                    label={t('SMP.PLAN.DETECT_ONLY_MODE')}
                />

                <EmptyRow />

                <SMCLabel><b>{t('SMP.DESCRIPTION')}: </b>{t('SMP.PLAN.TE.LINE3')}</SMCLabel>
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseThreatEmulation;